import React from "react";
import Icon from "./icon";
import { Link } from "gatsby";
import { imageUrlFor } from "../lib/image-url";
import { buildImageObj } from "../lib/helpers";

import * as styles from "../styles/components/integration-card.module.css";

const PartnerCard = (props) => {

  const {
    partnerItem,
    title
  } = props;

  const truncate = (input) => input.length > 80 ? `${input.substring(0, 80)}...` : input;

  return (
    <div className={styles.root}>
      {partnerItem.slug
        && <Link className={styles.link} to={`/partners/${partnerItem.slug}`}>
            {partnerItem.logo && 
              <div className={styles.logo}>
                <img
                  src={imageUrlFor(buildImageObj(partnerItem.logo)).url()}
                  alt={partnerItem.slug}
                />
              </div>
            }
            {partnerItem.title && 
              <>
                {title
                  ? <h2 className="h5">{partnerItem.title}</h2>
                  : <h3 className="h5">{partnerItem.title}</h3>
                }
              </>
            }
            {partnerItem.description && <p>{truncate(partnerItem.description)}</p>}
            <span className={styles.linkIcon}><Icon symbol="more" /></span>
          </Link>
      }
    </div>
  );
}

export default PartnerCard;
